document.addEventListener("DOMContentLoaded", () => {
  /* Cache key DOM elements for easy reference */
  const truckModal = document.getElementById('truck-select-modal');
  const modelSelector = document.getElementById("select_model");
  const radioButtons = modelSelector.querySelectorAll('label input[name="truck_radio_buttons"]');
  const selectGenHeading = document.getElementById("select-model-heading");
  const selectEl = document.getElementById("select_gen");
  const placeholder = selectEl.querySelector('.placeholder');
  const confirmButton = document.getElementById("truckConfirm");
  const clearSelection = document.getElementById("truckClear");
  const cancelSelect = document.getElementById("truckCancel");
  const mainMenu = document.querySelector('main-menu');
  const selectItem = document.querySelector('.select-item');
  const header = document.querySelector('.main-header');
  const mainTruckNav = document.querySelector('.main-truck-nav');

  // Format the header ID to use for fetching the updated menu
  let headerFormatted = header ? header.id.replace('shopify-section-', '') : null;

  /* Utility Function:
   * Updates the main menu content by fetching the section identified by headerFormatted.
   */
  async function updateMainMenu() {
    if (headerFormatted) {
      try {
        const response = await fetch(`/?section_id=${headerFormatted}`);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newHeader = doc.querySelector('.header');
        const currentHeader = document.querySelector('.header');

        if (newHeader && currentHeader) {
          // Update header data attributes
          const newTruckSelected = newHeader.getAttribute('data-truck-selected');
          const newTruckFilter = newHeader.getAttribute('data-truck-filter');
          const newTruckTitle = newHeader.getAttribute('data-truck-title');

          if (newTruckSelected !== null) {
            currentHeader.setAttribute('data-truck-selected', newTruckSelected);
          } else {
            currentHeader.removeAttribute('data-truck-selected');
          }

          if (newTruckFilter !== null) {
            currentHeader.setAttribute('data-truck-filter', newTruckFilter);
          } else {
            currentHeader.removeAttribute('data-truck-filter');
          }

          // Also sync the truck title for downstream consumers (e.g., predictive search UI)
          if (newTruckTitle !== null) {
            currentHeader.setAttribute('data-truck-title', newTruckTitle);
          } else {
            currentHeader.removeAttribute('data-truck-title');
          }

          // Replace specific elements only
          const currentMainMenu = currentHeader.querySelector('main-menu');
          const newMainMenu = newHeader.querySelector('main-menu');
          if (currentMainMenu && newMainMenu) {
            currentMainMenu.replaceWith(newMainMenu);
          }

          const currentTruckSelect = currentHeader.querySelector('#embark-select-truck');
          const newTruckSelect = newHeader.querySelector('#embark-select-truck');
          if (currentTruckSelect && newTruckSelect) {
            currentTruckSelect.replaceWith(newTruckSelect);
          }

          const predictiveSearch = currentHeader.querySelector('.js-search-results');
          const newPredictiveSearch = newHeader.querySelector('.js-search-results');
          if (predictiveSearch && newPredictiveSearch) {
            predictiveSearch.replaceWith(newPredictiveSearch);
          }

          // Dispatch custom event to re-initialize predictive search
          document.dispatchEvent(new CustomEvent('dispatch:predictive-search:reinitialize'));
        }
      } catch (error) {
        console.error("Error updating main menu:", error);
      }
    }
  }

  /* Reset Function:
   * Clears the truck selection UI, resets the radio buttons, disables the select and confirm button,
   * removes any truck-selected styling, and updates the main menu.
   */
  async function resetTruckSelection() {
    // Uncheck all truck radio buttons
    radioButtons.forEach(radio => radio.checked = false);

    // Reset select element to its placeholder and disable user input
    selectEl.value = placeholder.value;
    selectEl.disabled = true;
    confirmButton.disabled = true;
    selectGenHeading.classList.add('disabled');

    // Remove truck selection styling
    mainTruckNav.classList.remove('truck-is-selected');
    selectItem.classList.add('active');

    // Unwrap all options (remove any <span> wrappers added for iOS)
    toggleOptionWrapping(selectEl, '');

    document.documentElement.style.setProperty('--mobile-nav-header', `0px`);

    // Refresh main menu content if available
    if (headerFormatted) {
      await updateMainMenu();
    }
  }

  /* Toggle Option Wrapping:
   * For iOS compatibility, options not matching the selected truck are wrapped in a <span>
   * so that "display: none" is respected.
   *
   * @param {HTMLElement} selectElement - The select element containing options.
   * @param {string} matchValue - The value to match for unwrapping options.
   * @param {object} [menu=null] - Optional truck data to auto-select a matching option.
   */
  function toggleOptionWrapping(selectElement, matchValue, menu = null) {
    const options = selectElement.querySelectorAll('.real-option');
    options.forEach(option => {
      // Updated to match new value format: "brand-handle"
      const optionBrand = option.getAttribute('data-truck-brand');
      const isMatch = optionBrand === matchValue;

      if (isMatch && option.parentNode.tagName === 'SPAN') {
        // Unwrap the option from its <span> wrapper
        const spanWrapper = option.parentNode;
        spanWrapper.parentNode.insertBefore(option, spanWrapper);
        spanWrapper.remove();
      } else if (!isMatch && option.parentNode.tagName !== 'SPAN') {
        // Wrap the option in a <span> to hide it on iOS devices
        const spanWrapper = document.createElement('span');
        option.parentNode.insertBefore(spanWrapper, option);
        spanWrapper.appendChild(option);
      }

      // If truck data is provided, auto-select the option that matches brand and handle.
      if (menu) {
        const isBrandMatch = option.getAttribute('data-truck-brand') === menu.parent;
        const isHandleMatch = option.getAttribute('data-truck-handle') === menu.handle;
        if (isBrandMatch && isHandleMatch) {
          option.selected = true;
          confirmButton.disabled = false;
        }
      }
    });
  }

  /* Event Listener: When a radio button is clicked, reset the select element
   * to its placeholder, enable it, and update option visibility based on the selected truck.
   */
  radioButtons.forEach(radio => {
    radio.addEventListener("click", () => {
      selectEl.value = placeholder.value;
      confirmButton.disabled = true;
      selectEl.disabled = false;
      selectGenHeading.classList.remove('disabled');
      toggleOptionWrapping(selectEl, radio.value);
    });
  });

  /* Event Listener: When the truck modal opens, update option visibility
   * based on the currently selected radio button.
   */
  document.addEventListener('on:modal:open', (event) => {
    if (event.detail.modal === truckModal) {
      const selectedRadio = modelSelector.querySelector(":checked");
      if (selectedRadio) {
        toggleOptionWrapping(selectEl, selectedRadio.value);
      }
    }
  });

  /* Event Listener: Enable the confirm button when the user selects an option.
   */
  selectEl.addEventListener("change", () => {
    if (selectEl.value !== null) {
      confirmButton.disabled = false;
    }
  });

  /* Loading indicator functions */
  function showTruckLoading() {
    const modalWindow = truckModal.querySelector('.modal__window');
    if (modalWindow) {
      console.log('modalWindow', modalWindow);
      modalWindow.classList.add('loading');
    }
  }
  function hideTruckLoading() {
    const modalWindow = truckModal.querySelector('.modal__window');
    if (modalWindow) {
      modalWindow.classList.remove('loading');
    }
  }

  /* Confirm Button Click:
   * When confirmed, update the truck selection, store the data, update the cart,
   * and refresh the main menu.
   */
  confirmButton.addEventListener("click", () => {
    showTruckLoading();
    // Show truck notification only on the first selection.
    const truckNotification = localStorage.getItem('ddc-truck-notification');
    if (!truckNotification) {
      console.log('setting truck notification to true');
      localStorage.setItem('ddc-truck-notification', 'true');
    }

    const selectedRadio = modelSelector.querySelector(":checked");
    if (!selectedRadio) {
      hideTruckLoading();
      return; // Exit if no radio button is selected
    }

    const selectedOption = selectEl.querySelector("option:checked");

    const truckData = {
      title: selectedOption.getAttribute("data-truck-title"),
      parent: selectedOption.getAttribute("data-truck-brand"),
      handle: selectedOption.getAttribute("data-truck-handle"),
      make: selectedOption.getAttribute("data-truck-make")
    };

    if (truckData.handle) {
      fetchMenuData(truckData).finally(hideTruckLoading);
    } else {
      hideTruckLoading();
    }
  });

  /* Clear Selection Button:
   * Resets the truck form by clearing the cart attributes, localStorage, and UI.
   */
  clearSelection.addEventListener("click", async () => {
    showTruckLoading();
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            _truck_parent: '',
            _truck_make: '',
            _truck_handle: '',
            _truck_title: ''
          }
        })
      });
      const data = await response.json();
      console.log('Cart attributes updated:', data.attributes);

      // Clear saved truck data from localStorage
      localStorage.removeItem("my-truck");

      // Reset the truck selection UI
      await resetTruckSelection();
    } catch (error) {
      console.error('Error updating cart attributes:', error);
    } finally {
      hideTruckLoading();
    }
  });

  /* Build Menus:
   * Sets the current truck selection in the UI and updates various styling and state,
   * then closes the truck selection modal.
   *
   * @param {object} menu - Truck data containing parent, make, handle, and title.
   */
  async function buildMenus(menu) {
    // Set the corresponding radio button as checked based on truck data.
    const setRadio = modelSelector.querySelector(`[value="${menu.parent}"]`);
    if (setRadio) {
      setRadio.checked = true;
    }
    // Update option wrapping and enable the confirm button
    toggleOptionWrapping(selectEl, setRadio ? setRadio.value : '', menu);
    confirmButton.disabled = false;

    // Update navigation UI to indicate a truck has been selected.
    mainTruckNav.classList.add('truck-is-selected');
    selectGenHeading.classList.remove('disabled');
    selectEl.disabled = false;
    selectItem.classList.remove('active');
    cancelSelect.classList.remove('disabled');

    // Close the truck selection modal by dispatching a custom event.
    truckModal.dispatchEvent(new CustomEvent('modalClose'));
    // Dispatch a custom event to close the mobile menu
    document.dispatchEvent(new CustomEvent('closeMobileMenu'));
  }

  /* Fetch Menu Data:
   * Updates localStorage and the cart with the selected truck information,
   * refreshes the main menu, and then builds the truck menus.
   *
   * @param {object} truckData - Contains title, parent, handle, and make.
   */
  async function fetchMenuData({ title, parent, handle, make }) {
    try {
      const storedMenuJSON = localStorage.getItem("my-truck");
      const storedMenu = storedMenuJSON ? JSON.parse(storedMenuJSON) : null;

      // Exit early if there is no truck handle and no stored menu exists.
      if (!handle && !storedMenu) {
        console.log('No handle provided and no stored menu exists; doing nothing.');
        return;
      }

      // Prepare and save the current truck data.
      const truckData = { parent, make, handle, title };
      localStorage.setItem('my-truck', JSON.stringify(truckData));

      // Update the cart with the selected truck attributes.
      const cartResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            _truck_parent: parent,
            _truck_make: make,
            _truck_handle: handle,
            _truck_title: title
          }
        })
      });
      const cartData = await cartResponse.json();
      console.log('Cart attributes updated:', cartData.attributes);

      // Update the main menu if header information is available.
      if (headerFormatted) {
        await updateMainMenu();
      }

      // Build the truck menus using the updated truck data.
      buildMenus(truckData);
    } catch (error) {
      // If an error message isn't already displayed, insert one after the select element.
      if (!selectEl._errorMessageEl) {
        const errorMessageHTML = `
          <div class="alert my-5 bg-error-bg text-error-text" role="alert">
            <p class="h6">Damn, something broke!</p>
            <p class="mb-0">
              Sorry about that 'bud. There was an error loading the selected truck, please try again.
              <br>
              If you keep receiving this error, please <a class="link" target="_self" href="mailto:support@dirtydieselcustom.ca">contact our support</a>.
            </p>
          </div>
        `;
        selectEl.insertAdjacentHTML('afterend', errorMessageHTML);
        selectEl._errorMessageEl = selectEl.nextElementSibling;
      }
      console.error('Error loading navigation section:', error);
    }
  }
});